import { CSSTransition } from 'react-transition-group';
import { HTMLAttributes, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorGif from '@img/gif/error.webp';
import Spinner from '@com/utils/Spinner';
import styled from '@emotion/styled';

interface Props extends HTMLAttributes<HTMLDivElement> {
  isSuccess: boolean;
  isError: boolean;
  children: JSX.Element[] | JSX.Element;
  iconSize?: number;
  iconClassName?: string;
  animateName?: string;
  duration?: number;
}

function LoadingContainer(props: Props): JSX.Element {
  const { t } = useTranslation();
  const nodeRef = useRef(null);
  const {
    isSuccess,
    isError,
    children,
    iconSize = 256,
    iconClassName,
    className,
    animateName,
    duration = 500,
  } = props;

  const StyledImage = styled.img`
    ${`${iconSize}px`}
    ${`${iconSize}px`}
  `;

  return (
    <>
      <CSSTransition
        mountOnEnter
        unmountOnExit
        classNames={animateName ?? 'content'}
        in={!isSuccess && !isError}
        nodeRef={nodeRef}
        timeout={500}
      >
        <div
          className={
            iconClassName ??
            'w-100 h-100 d-flex justify-content-center align-items-center'
          }
        >
          <Spinner height={iconSize} width={iconSize} />
        </div>
      </CSSTransition>
      <CSSTransition
        mountOnEnter
        unmountOnExit
        classNames={animateName ?? 'content'}
        in={isError}
        nodeRef={nodeRef}
        timeout={duration}
      >
        <div
          className={
            iconClassName ??
            'w-100 h-100 d-flex justify-content-center align-items-center'
          }
        >
          <div className="d-flex flex-column align-items-center">
            <StyledImage height={iconSize} src={ErrorGif} width={iconSize} />
            <span className="h3">{t('errorMsg.general.fetchFailed')}</span>
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        mountOnEnter
        unmountOnExit
        classNames="content"
        in={isSuccess}
        nodeRef={nodeRef}
        timeout={500}
      >
        <div className={className ?? 'themesflat-container'}>{children}</div>
      </CSSTransition>
    </>
  );
}

export default LoadingContainer;
